module.exports = __webpack_public_path__ + "img/newspapers_button_previous_down.e31dbc1d.png";